var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useCallback, useEffect, useMemo, useReducer, useRef } from 'react';
import { dataTransferItemsHaveFiles, dataTransferItemsToFiles } from 'react-file-utils';
import { logChatPromiseExecution, } from 'stream-chat';
import { useChannelContext } from '../../../context/ChannelContext';
import { generateRandomId } from '../../../utils';
/**
 * Get attachment type from MIME type
 */
var getAttachmentTypeFromMime = function (mime) {
    if (mime.includes('video/'))
        return 'media';
    if (mime.includes('audio/'))
        return 'audio';
    return 'file';
};
var apiMaxNumberOfFiles = 10;
var emptyFileUploads = {};
var emptyImageUploads = {};
/**
 * Initializes the state. Empty if the message prop is falsy.
 */
var initState = function (message) {
    var _a, _b, _c;
    if (!message) {
        return {
            attachments: [],
            emojiPickerIsOpen: false,
            fileOrder: [],
            fileUploads: __assign({}, emptyFileUploads),
            imageOrder: [],
            imageUploads: __assign({}, emptyImageUploads),
            mentioned_users: [],
            numberOfUploads: 0,
            text: '',
        };
    }
    // if message prop is defined, get image uploads, file uploads, text, etc. from it
    var imageUploads = ((_a = message.attachments) === null || _a === void 0 ? void 0 : _a.filter(function (_a) {
        var type = _a.type;
        return type === 'image';
    }).reduce(function (acc, attachment) {
        var id = generateRandomId();
        acc[id] = {
            file: {
                name: attachment.fallback,
            },
            id: id,
            state: 'finished',
            url: attachment.image_url,
        };
        return acc;
    }, {})) || {};
    var imageOrder = Object.keys(imageUploads);
    var fileUploads = ((_b = message.attachments) === null || _b === void 0 ? void 0 : _b.filter(function (_a) {
        var type = _a.type;
        return type === 'file';
    }).reduce(function (acc, attachment) {
        var id = generateRandomId();
        acc[id] = {
            file: {
                name: attachment.title || '',
                size: attachment.file_size,
                type: attachment.mime_type,
            },
            id: id,
            state: 'finished',
            url: attachment.asset_url,
        };
        return acc;
    }, {})) || {};
    var fileOrder = Object.keys(fileUploads);
    var numberOfUploads = fileOrder.length + imageOrder.length;
    var attachments = ((_c = message.attachments) === null || _c === void 0 ? void 0 : _c.filter(function (_a) {
        var type = _a.type;
        return type !== 'file' && type !== 'image';
    })) || [];
    var mentioned_users = message.mentioned_users || [];
    return {
        attachments: attachments,
        emojiPickerIsOpen: false,
        fileOrder: fileOrder,
        fileUploads: fileUploads,
        imageOrder: imageOrder,
        imageUploads: imageUploads,
        mentioned_users: mentioned_users,
        numberOfUploads: numberOfUploads,
        text: message.text || '',
    };
};
/**
 * MessageInput state reducer
 */
var messageInputReducer = function (state, action) {
    var _a, _b;
    switch (action.type) {
        case 'setEmojiPickerIsOpen':
            return __assign(__assign({}, state), { emojiPickerIsOpen: action.value });
        case 'setText':
            return __assign(__assign({}, state), { text: action.getNewText(state.text) });
        case 'clear':
            return {
                attachments: [],
                emojiPickerIsOpen: false,
                fileOrder: [],
                fileUploads: __assign({}, emptyFileUploads),
                imageOrder: [],
                imageUploads: __assign({}, emptyImageUploads),
                mentioned_users: [],
                numberOfUploads: 0,
                text: '',
            };
        case 'setImageUpload': {
            var imageAlreadyExists = state.imageUploads[action.id];
            if (!imageAlreadyExists && !action.file)
                return state;
            var imageOrder = imageAlreadyExists ? state.imageOrder : state.imageOrder.concat(action.id);
            var newUploadFields = __assign({}, action);
            delete newUploadFields.type;
            return __assign(__assign({}, state), { imageOrder: imageOrder, imageUploads: __assign(__assign({}, state.imageUploads), (_a = {}, _a[action.id] = __assign(__assign({}, state.imageUploads[action.id]), newUploadFields), _a)), numberOfUploads: imageAlreadyExists ? state.numberOfUploads : state.numberOfUploads + 1 });
        }
        case 'setFileUpload': {
            var fileAlreadyExists = state.fileUploads[action.id];
            if (!fileAlreadyExists && !action.file)
                return state;
            var fileOrder = fileAlreadyExists ? state.fileOrder : state.fileOrder.concat(action.id);
            var newUploadFields = __assign({}, action);
            delete newUploadFields.type;
            return __assign(__assign({}, state), { fileOrder: fileOrder, fileUploads: __assign(__assign({}, state.fileUploads), (_b = {}, _b[action.id] = __assign(__assign({}, state.fileUploads[action.id]), newUploadFields), _b)), numberOfUploads: fileAlreadyExists ? state.numberOfUploads : state.numberOfUploads + 1 });
        }
        case 'removeImageUpload': {
            if (!state.imageUploads[action.id])
                return state; // cannot remove anything
            var newImageUploads = __assign({}, state.imageUploads);
            delete newImageUploads[action.id];
            return __assign(__assign({}, state), { imageOrder: state.imageOrder.filter(function (_id) { return _id !== action.id; }), imageUploads: newImageUploads, numberOfUploads: state.numberOfUploads - 1 });
        }
        case 'removeFileUpload': {
            if (!state.fileUploads[action.id])
                return state; // cannot remove anything
            var newFileUploads = __assign({}, state.fileUploads);
            delete newFileUploads[action.id];
            return __assign(__assign({}, state), { fileOrder: state.fileOrder.filter(function (_id) { return _id !== action.id; }), fileUploads: newFileUploads, numberOfUploads: state.numberOfUploads - 1 });
        }
        case 'reduceNumberOfUploads': // TODO: figure out if we can just use uploadOrder instead
            return __assign(__assign({}, state), { numberOfUploads: state.numberOfUploads - 1 });
        case 'addMentionedUser':
            return __assign(__assign({}, state), { mentioned_users: state.mentioned_users.concat(action.user) });
        default:
            return state;
    }
};
/**
 * hook for MessageInput state
 */
export var useMessageInput = function (props) {
    var _a, _b;
    var additionalTextareaProps = props.additionalTextareaProps, clearEditingState = props.clearEditingState, doFileUploadRequest = props.doFileUploadRequest, doImageUploadRequest = props.doImageUploadRequest, errorHandler = props.errorHandler, focus = props.focus, message = props.message, noFiles = props.noFiles, overrideSubmitHandler = props.overrideSubmitHandler, parent = props.parent, publishTypingEvent = props.publishTypingEvent;
    var _c = useChannelContext(), channel = _c.channel, editMessage = _c.editMessage, maxNumberOfFiles = _c.maxNumberOfFiles, multipleUploads = _c.multipleUploads, sendMessage = _c.sendMessage;
    var _d = useReducer(messageInputReducer, message, initState), state = _d[0], dispatch = _d[1];
    var attachments = state.attachments, fileOrder = state.fileOrder, fileUploads = state.fileUploads, imageOrder = state.imageOrder, imageUploads = state.imageUploads, mentioned_users = state.mentioned_users, numberOfUploads = state.numberOfUploads, text = state.text;
    var emojiPickerRef = useRef(null);
    var textareaRef = useRef();
    // Focus
    useEffect(function () {
        if (focus && textareaRef.current) {
            textareaRef.current.focus();
        }
    }, [focus]);
    // Text + cursor position
    var newCursorPosition = useRef();
    var insertText = useCallback(function (textToInsert) {
        var maxLength = (additionalTextareaProps || {}).maxLength;
        if (!textareaRef.current) {
            dispatch({
                getNewText: function (text) {
                    var updatedText = text + textToInsert;
                    if (maxLength && updatedText.length > maxLength) {
                        return updatedText.slice(0, maxLength);
                    }
                    return updatedText;
                },
                type: 'setText',
            });
            return;
        }
        var _a = textareaRef.current, selectionEnd = _a.selectionEnd, selectionStart = _a.selectionStart;
        newCursorPosition.current = selectionStart + textToInsert.length;
        dispatch({
            getNewText: function (prevText) {
                var updatedText = prevText.slice(0, selectionStart) + textToInsert + prevText.slice(selectionEnd);
                if (maxLength && updatedText.length > maxLength) {
                    return updatedText.slice(0, maxLength);
                }
                return updatedText;
            },
            type: 'setText',
        });
    }, [additionalTextareaProps, newCursorPosition, textareaRef]);
    useEffect(function () {
        var textareaElement = textareaRef.current;
        if (textareaElement && newCursorPosition.current !== undefined) {
            textareaElement.selectionStart = newCursorPosition.current;
            textareaElement.selectionEnd = newCursorPosition.current;
            newCursorPosition.current = undefined;
        }
    }, [text, newCursorPosition]);
    var handleChange = useCallback(function (event) {
        event.preventDefault();
        if (!event || !event.target) {
            return;
        }
        var newText = event.target.value;
        dispatch({
            getNewText: function () { return newText; },
            type: 'setText',
        });
        if (publishTypingEvent && newText && channel) {
            logChatPromiseExecution(channel.keystroke(parent === null || parent === void 0 ? void 0 : parent.id), 'start typing event');
        }
    }, [channel, parent, publishTypingEvent]);
    // Emoji
    var closeEmojiPicker = useCallback(function (event) {
        if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
            dispatch({
                type: 'setEmojiPickerIsOpen',
                value: false,
            });
        }
    }, [emojiPickerRef]);
    var openEmojiPicker = useCallback(function (event) {
        dispatch({
            type: 'setEmojiPickerIsOpen',
            value: true,
        });
        // Prevent event from bubbling to document, so the close handler is never called for this event
        event.stopPropagation();
    }, []);
    var handleEmojiKeyDown = function (event) {
        if (event.key === ' ' || event.key === 'Enter' || event.key === 'Spacebar') {
            event.preventDefault();
            /**
             * TODO: fix the below at some point because this type casting is wrong
             * and just forced to not have warnings currently with the unknown casting
             */
            openEmojiPicker(event);
        }
    };
    var handleEmojiEscape = function (event) {
        if (event.key === 'Escape') {
            dispatch({
                type: 'setEmojiPickerIsOpen',
                value: false,
            });
        }
    };
    useEffect(function () {
        if (state.emojiPickerIsOpen) {
            document.addEventListener('click', closeEmojiPicker, false);
            document.addEventListener('keydown', handleEmojiEscape);
        }
        return function () {
            document.removeEventListener('click', closeEmojiPicker, false);
            document.removeEventListener('keydown', handleEmojiEscape);
        };
    }, [closeEmojiPicker, state.emojiPickerIsOpen]);
    var onSelectEmoji = useCallback(function (emoji) { return insertText(emoji.native); }, [
        insertText,
    ]);
    // Commands / mentions
    var getCommands = useCallback(function () { var _a, _b; return (_b = (_a = channel === null || channel === void 0 ? void 0 : channel.getConfig) === null || _a === void 0 ? void 0 : _a.call(channel)) === null || _b === void 0 ? void 0 : _b.commands; }, [channel]);
    var getUsers = useCallback(function () {
        if (!channel)
            return [];
        return __spreadArray(__spreadArray([], Object.values(channel.state.members).map(function (_a) {
            var user = _a.user;
            return user;
        })), Object.values(channel.state.watchers)).filter(function (_user, index, self) { return self.findIndex(function (user) { return (user === null || user === void 0 ? void 0 : user.id) === (_user === null || _user === void 0 ? void 0 : _user.id); }) === index; });
    }, [channel]);
    var onSelectItem = useCallback(function (item) {
        dispatch({ type: 'addMentionedUser', user: item });
    }, []);
    // Submitting
    var getAttachmentsFromUploads = useCallback(function () {
        var imageAttachments = imageOrder
            .map(function (id) { return imageUploads[id]; })
            .filter(function (upload) { return upload.state !== 'failed'; })
            .filter(function (_a, _, self) {
            var id = _a.id, url = _a.url;
            return self.every(function (upload) { return upload.id === id || upload.url !== url; });
        })
            .map(function (upload) {
            return ({
                fallback: upload.file.name,
                image_url: upload.url,
                type: 'image',
            });
        });
        var fileAttachments = fileOrder
            .map(function (id) { return fileUploads[id]; })
            .filter(function (upload) { return upload.state !== 'failed'; })
            .map(function (upload) {
            return ({
                asset_url: upload.url,
                file_size: upload.file.size,
                mime_type: upload.file.type,
                title: upload.file.name,
                type: getAttachmentTypeFromMime(upload.file.type || ''),
            });
        });
        return __spreadArray(__spreadArray(__spreadArray([], attachments), imageAttachments), fileAttachments);
    }, [imageOrder, imageUploads, fileOrder, fileUploads, attachments]);
    var handleSubmit = function (event) {
        event.preventDefault();
        var trimmedMessage = text.trim();
        var isEmptyMessage = trimmedMessage === '' ||
            trimmedMessage === '>' ||
            trimmedMessage === '``````' ||
            trimmedMessage === '``' ||
            trimmedMessage === '**' ||
            trimmedMessage === '____' ||
            trimmedMessage === '__' ||
            trimmedMessage === '****';
        if (isEmptyMessage && numberOfUploads === 0) {
            return;
        }
        // the channel component handles the actual sending of the message
        var someAttachmentsUploading = Object.values(imageUploads).some(function (upload) { return upload.state === 'uploading'; }) ||
            Object.values(fileUploads).some(function (upload) { return upload.state === 'uploading'; });
        if (someAttachmentsUploading) {
            // TODO: show error to user that they should wait until image is uploaded
            return;
        }
        var newAttachments = getAttachmentsFromUploads();
        // Instead of checking if a user is still mentioned every time the text changes,
        // just filter out non-mentioned users before submit, which is cheaper
        // and allows users to easily undo any accidental deletion
        var actualMentionedUsers = Array.from(new Set(mentioned_users.filter(function (_a) {
            var id = _a.id, name = _a.name;
            return text.includes("@" + id) || text.includes("@" + name);
        })));
        var updatedMessage = {
            attachments: newAttachments,
            mentioned_users: actualMentionedUsers,
            text: text,
        };
        if (!!message && editMessage) {
            // TODO: Remove this line and show an error when submit fails
            if (clearEditingState) {
                clearEditingState();
            }
            var updateMessagePromise = editMessage(__assign(__assign({}, updatedMessage), { id: message.id })).then(clearEditingState);
            logChatPromiseExecution(updateMessagePromise, 'update message');
            dispatch({ type: 'clear' });
        }
        else if (overrideSubmitHandler && channel) {
            overrideSubmitHandler(__assign(__assign({}, updatedMessage), { parent: parent }), channel.cid);
            dispatch({ type: 'clear' });
        }
        else if (sendMessage) {
            var sendMessagePromise = sendMessage(__assign(__assign({}, updatedMessage), { parent: parent }));
            logChatPromiseExecution(sendMessagePromise, 'send message');
            dispatch({ type: 'clear' });
        }
        if (channel && publishTypingEvent)
            logChatPromiseExecution(channel.stopTyping(), 'stop typing');
    };
    // Attachments
    // Files
    var uploadFile = useCallback(function (id) {
        dispatch({ id: id, state: 'uploading', type: 'setFileUpload' });
    }, []);
    var removeFile = useCallback(function (id) {
        // TODO: cancel upload if still uploading
        dispatch({ id: id, type: 'removeFileUpload' });
    }, []);
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var upload, file, id, response, error_1, alreadyRemoved;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!channel)
                            return [2 /*return*/];
                        upload = Object.values(fileUploads).find(function (fileUpload) { return fileUpload.state === 'uploading' && fileUpload.file; });
                        if (!upload)
                            return [2 /*return*/];
                        file = upload.file, id = upload.id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!doFileUploadRequest) return [3 /*break*/, 3];
                        return [4 /*yield*/, doFileUploadRequest(file, channel)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, channel.sendFile(file)];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        console.warn(error_1);
                        alreadyRemoved = false;
                        dispatch({ type: 'reduceNumberOfUploads' });
                        if (!fileUploads[id]) {
                            alreadyRemoved = true;
                        }
                        else {
                            dispatch({ id: id, state: 'failed', type: 'setFileUpload' });
                        }
                        if (!alreadyRemoved && errorHandler) {
                            // TODO: verify if the parameters passed to the error handler actually make sense
                            errorHandler(error_1, 'upload-file', file);
                        }
                        return [2 /*return*/];
                    case 7:
                        // If doImageUploadRequest returns any falsy value, then don't create the upload preview.
                        // This is for the case if someone wants to handle failure on app level.
                        if (!response) {
                            removeFile(id);
                            return [2 /*return*/];
                        }
                        dispatch({
                            id: id,
                            state: 'finished',
                            type: 'setFileUpload',
                            url: response.file,
                        });
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [fileUploads, channel, doFileUploadRequest, errorHandler, removeFile]);
    // Images
    var removeImage = useCallback(function (id) {
        dispatch({ id: id, type: 'removeImageUpload' });
        // TODO: cancel upload if still uploading
    }, []);
    var uploadImage = useCallback(function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var img, file, response, error_2, alreadyRemoved;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    img = imageUploads[id];
                    if (!img || !channel)
                        return [2 /*return*/];
                    file = img.file;
                    if (img.state !== 'uploading') {
                        dispatch({ id: id, state: 'uploading', type: 'setImageUpload' });
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!doImageUploadRequest) return [3 /*break*/, 3];
                    return [4 /*yield*/, doImageUploadRequest(file, channel)];
                case 2:
                    response = _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, channel.sendImage(file)];
                case 4:
                    response = _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_2 = _a.sent();
                    console.warn(error_2);
                    alreadyRemoved = false;
                    dispatch({ type: 'reduceNumberOfUploads' });
                    if (!imageUploads[id]) {
                        alreadyRemoved = true;
                    }
                    else {
                        dispatch({ id: id, state: 'failed', type: 'setImageUpload' });
                    }
                    if (!alreadyRemoved && errorHandler) {
                        // TODO: verify if the parameters passed to the error handler actually make sense
                        errorHandler(error_2, 'upload-image', __assign(__assign({}, file), { id: id }));
                    }
                    return [2 /*return*/];
                case 7:
                    // If doImageUploadRequest returns any falsy value, then don't create the upload preview.
                    // This is for the case if someone wants to handle failure on app level.
                    if (!response) {
                        removeImage(id);
                        return [2 /*return*/];
                    }
                    dispatch({
                        id: id,
                        state: 'finished',
                        type: 'setImageUpload',
                        url: response.file,
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [imageUploads, channel, doImageUploadRequest, errorHandler, removeImage]);
    useEffect(function () {
        if (FileReader) {
            var upload = Object.values(imageUploads).find(function (imageUpload) {
                return imageUpload.state === 'uploading' && !!imageUpload.file && !imageUpload.previewUri;
            });
            if (upload) {
                var file = upload.file, id_1 = upload.id;
                // TODO: Possibly use URL.createObjectURL instead. However, then we need
                // to release the previews when not used anymore though.
                var reader_1 = new FileReader();
                reader_1.onload = function (event) {
                    var _a;
                    if (typeof ((_a = event.target) === null || _a === void 0 ? void 0 : _a.result) !== 'string')
                        return;
                    dispatch({
                        id: id_1,
                        previewUri: event.target.result,
                        type: 'setImageUpload',
                    });
                };
                reader_1.readAsDataURL(file);
                uploadImage(id_1);
                return function () {
                    reader_1.onload = null;
                };
            }
        }
        return;
    }, [imageUploads, uploadImage]);
    // Number of files that the user can still add. Should never be more than the amount allowed by the API.
    // If multipleUploads is false, we only want to allow a single upload.
    var maxFilesAllowed = useMemo(function () { return (!multipleUploads ? 1 : maxNumberOfFiles || apiMaxNumberOfFiles); }, [maxNumberOfFiles, multipleUploads]);
    // return !multipleUploads ? 1 : maxNumberOfFiles || apiMaxNumberOfFiles;
    var maxFilesLeft = maxFilesAllowed - numberOfUploads;
    var uploadNewFiles = useCallback(function (files) {
        Array.from(files)
            .slice(0, maxFilesLeft)
            .forEach(function (file) {
            var id = generateRandomId();
            if (file.type.startsWith('image/') &&
                !file.type.endsWith('.photoshop') // photoshop files begin with 'image/'
            ) {
                dispatch({ file: file, id: id, state: 'uploading', type: 'setImageUpload' });
            }
            else if (file instanceof File && !noFiles) {
                dispatch({ file: file, id: id, state: 'uploading', type: 'setFileUpload' });
            }
        });
    }, [maxFilesLeft, noFiles]);
    var onPaste = useCallback(function (clipboardEvent) {
        (function (event) { return __awaiter(void 0, void 0, void 0, function () {
            var items, plainTextPromise, _loop_1, i, state_1, fileLikes, pastedText;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        items = event.clipboardData.items;
                        if (!dataTransferItemsHaveFiles(Array.from(items)))
                            return [2 /*return*/];
                        event.preventDefault();
                        plainTextPromise = undefined;
                        _loop_1 = function (i) {
                            var item = items[i];
                            if (item.kind === 'string' && item.type === 'text/plain') {
                                plainTextPromise = new Promise(function (resolve) {
                                    item.getAsString(function (string) {
                                        resolve(string);
                                    });
                                });
                                return "break";
                            }
                        };
                        for (i = 0; i < items.length; i++) {
                            state_1 = _loop_1(i);
                            if (state_1 === "break")
                                break;
                        }
                        return [4 /*yield*/, dataTransferItemsToFiles(Array.from(items))];
                    case 1:
                        fileLikes = _a.sent();
                        if (fileLikes.length) {
                            uploadNewFiles(fileLikes);
                            return [2 /*return*/];
                        }
                        if (!plainTextPromise) return [3 /*break*/, 3];
                        return [4 /*yield*/, plainTextPromise];
                    case 2:
                        pastedText = _a.sent();
                        insertText(pastedText);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); })(clipboardEvent);
    }, [insertText, uploadNewFiles]);
    var isUploadEnabled = ((_b = (_a = channel === null || channel === void 0 ? void 0 : channel.getConfig) === null || _a === void 0 ? void 0 : _a.call(channel)) === null || _b === void 0 ? void 0 : _b.uploads) !== false;
    return __assign(__assign({}, state), { 
        /**
         * TODO: fix the below at some point because this type casting is wrong
         * and just forced to not have warnings currently with the unknown casting
         */
        closeEmojiPicker: closeEmojiPicker, emojiPickerRef: emojiPickerRef,
        getCommands: getCommands,
        getUsers: getUsers,
        handleChange: handleChange,
        handleEmojiKeyDown: handleEmojiKeyDown,
        handleSubmit: handleSubmit,
        insertText: insertText,
        isUploadEnabled: isUploadEnabled,
        maxFilesLeft: maxFilesLeft,
        onPaste: onPaste,
        onSelectEmoji: onSelectEmoji,
        onSelectItem: onSelectItem,
        openEmojiPicker: openEmojiPicker,
        removeFile: removeFile,
        removeImage: removeImage,
        textareaRef: textareaRef,
        uploadFile: uploadFile,
        uploadImage: uploadImage,
        uploadNewFiles: uploadNewFiles });
};
